import React, { useContext, useState } from 'react';
import { AdminContext } from '../../../context/admin-context';
import Svg from '../icons/svg';
import './replies-style.css';

function Replies(props) {
  const { provider, id, replies } = props;
  const admin = useContext(AdminContext);
  const [showReplies, setShowReplies] = useState(false);

  const toggleShowReplies = () => {
    setShowReplies(!showReplies);
  };

  const addReplies = () => {
    provider.addReplies(id);
  };

  const removeReplies = () => {
    provider.removeReplies(id);
  };

  if (replies) {
    return (
      <li className="p-relative">
        <ul className="replies">
          <li className="d-inline-block w-100">
            {admin.auth.value && showReplies && (
              <button type="button" className="btn text-danger remove-replies" onClick={removeReplies}>
                <Svg name={'trash'} width={14} />
              </button>
            )}
            <div className="f-00auto justify-content-start align-items-stretch align-content-stretch">
              {showReplies && (
                <div className="font-size-4 line-height-2 f-shrink-1 d-inline-block mb-8p wb-break-all pl-16p pl-sm-24p">
                  {replies}
                </div>
              )}
              <button
                className="load d-inline p-relative u-select-none p-0 text-right"
                type="button"
                onClick={toggleShowReplies}
              >
                <div className="line" />
                {showReplies ? <span className="show c-p">بستن پاسخ</span> : <span className="show c-p">مشاهده پاسخ</span>}
              </button>
            </div>
          </li>
        </ul>
      </li>
    );
  } else if (admin.auth.value) {
    return (
      <li>
        <ul className="replies">
          <li className="d-inline-block">
            <div className="f-00auto justify-content-start f-row align-items-stretch align-content-stretch">
              <button className="load d-inline p-relative u-select-none p-0 c-p" type="button" onClick={addReplies}>
                <div className="line" />
                <span className="show">پاسخ</span>
              </button>
            </div>
          </li>
        </ul>
      </li>
    );
  } else {
    return <></>;
  }
}

export default Replies;
